import { type MatrixEvent, M_LOCATION, type MLocationEvent } from "matrix-js-sdk/src/matrix";

type LocationEvent = { geo_uri: string } & MLocationEvent;

/**
 * Find the geo-URI contained within a location event.
 */
export const locationEventGeoUri = (mxEvent: MatrixEvent): string => {
    // unfortunately we're stuck supporting legacy `content.geo_uri`
    // events until the end of days, or until we figure out mutable
    // events - so folks can read their old chat history correctly.
    // https://github.com/matrix-org/matrix-doc/issues/3516
    const content = mxEvent.getContent<LocationEvent>();
    const loc = M_LOCATION.findIn(content);
    return loc?.uri ?? content["geo_uri"];
};
